import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M959.341941,1355.2828 C963.628574,1355.28974 980.239059,1355.46322 1005.17647,1359.80016 L1005.17647,1359.80016 L1001.78824,1415.14134 C1000.65882,1444.50604 975.811765,1468.22369 946.447059,1468.22369 C880.941176,1468.22369 835.764706,1487.42369 805.270588,1525.82369 C736.376471,1613.91781 760.094118,1788.97663 774.776471,1849.96487 C779.294118,1866.90604 774.776471,1884.97663 764.611765,1898.52957 C753.317647,1912.08251 737.505882,1919.9884 720.564706,1919.9884 L720.564706,1919.9884 L508.235294,1919.9884 C476.611765,1919.9884 451.764706,1895.14134 451.764706,1863.51781 L451.764706,1863.51781 L451.764706,1355.28251 Z M1587.16235,31.2392196 C1598.79529,7.74745494 1624.77176,-4.33725094 1650.63529,1.42274906 C1676.16,7.52157259 1694.11765,30.2227491 1694.11765,56.425102 L1694.11765,56.425102 L1694.11765,570.420396 C1822.87059,596.622749 1920,710.693337 1920,847.013337 C1920,983.333337 1822.87059,1097.51687 1694.11765,1123.71922 L1694.11765,1123.71922 L1694.11765,1637.60157 C1694.11765,1663.80393 1676.16,1686.61804 1650.63529,1692.60393 C1646.23059,1693.6204 1641.93882,1694.07216 1637.64706,1694.07216 C1616.52706,1694.07216 1596.87529,1682.32628 1587.16235,1662.9004 C1379.23765,1247.16393 964.178824,1242.30745 960,1242.30745 L960,1242.30745 L395.294118,1242.30745 C239.548235,1242.30745 112.941176,1115.7004 112.941176,959.954514 L112.941176,959.954514 L112.941176,903.483926 L56.4705882,903.483926 C25.2988235,903.483926 0,878.298043 0,847.013337 C0,815.841573 25.2988235,790.542749 56.4705882,790.542749 L56.4705882,790.542749 L112.941176,790.542749 L112.941176,734.072161 C112.941176,578.43922 239.548235,451.71922 395.294118,451.71922 L395.294118,451.71922 L959.887059,451.71922 C976.828235,451.606278 1380.36706,444.716867 1587.16235,31.2392196 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAnnouncementSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAnnouncementSolid, _Component);

  var _super = _createSuper(IconAnnouncementSolid);

  function IconAnnouncementSolid() {
    _classCallCheck(this, IconAnnouncementSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAnnouncementSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAnnouncement",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAnnouncementSolid.displayName = "IconAnnouncementSolid";
  return IconAnnouncementSolid;
}(Component);

IconAnnouncementSolid.glyphName = 'announcement';
IconAnnouncementSolid.variant = 'Solid';
IconAnnouncementSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAnnouncementSolid;
export { IconAnnouncementSolid };